/** 领取成功页 query，equityType：1 微信 / 2 京东 / 3 积分 / 4+ 实物 */
const WX_CODE_KEY = 'ydsh-ph-h5-bankv3-wxcode'

export function isPhysicalEquityType(equityType) {
  const type = Number(equityType)
  return !Number.isNaN(type) && type >= 4
}

export function getWxAuthCode() {
  return sessionStorage.getItem(WX_CODE_KEY) || ''
}

/** 组装 receive 请求体；微信立减金需带 session 中的 code */
export function buildReceiveParams(rewardParms = {}, equityType) {
  const type = Number(equityType)
  const params = {
    gradeNum:
      rewardParms.gradeNum != null && rewardParms.gradeNum !== ''
        ? Number(rewardParms.gradeNum)
        : undefined,
    appId: rewardParms.appId || '',
    openId: rewardParms.openId || '',
    equityType: type,
  }
  if (type === 1) {
    params.code = getWxAuthCode()
  }
  return params
}

export function buildSuccessQuery(data, equityType) {
  return {
    equityType: String(equityType),
    equityName: data?.equityName || '',
    availableEndTime: data?.availableEndTime || '',
    cardNo: data?.cardNo || '',
    cardPwd: data?.cardPwd || '',
    pointsNum: data?.pointsNum != null ? String(data.pointsNum) : '',
  }
}

/** 商城积分成功页展示文案，优先取 equityName 中的档位积分 */
export function formatPointsDisplayName(equityName, pointsNum) {
  const name = String(equityName || '').trim()
  if (name) {
    const leadingNum = name.match(/^(\d+)/)
    if (leadingNum) {
      return `商城积分${leadingNum[1]}`
    }
    if (name.includes('积分')) {
      return name
    }
  }
  const num = String(pointsNum ?? '').trim()
  if (num) {
    return `商城积分${num}`
  }
  return '商城积分'
}

export function isReceiveSuccess(data) {
  return Number(data?.result) === 1
}

/** 领取接口失败文案，优先取顶层 message */
export function getReceiveErrorMessage(res, fallback = '领取失败') {
  if (!res) return fallback
  return res.message || res.data?.message || fallback
}
